
const NS = 'HeaderFilterComponent';

// requiring html templates so that hot reloading works
const template = require('./headerFilter.component.html');

export default {
  bindings: {
    currentItem: '<',
    items: '<',
    onItemChanged: '&',
    title: '@'
  },
  template,
  controllerAs: 'vm',
  controller
};

// just exported for unit tests
export function controller($scope, unregister) {
  "ngInject";

  const vm = this;

  vm.onChanged = () => {
    if (vm.onItemChanged) {
      vm.onItemChanged({currentItem: vm.currentItem});
    }
  };
}
